<template>
  <div class="themes_wrap">
    <v-toolbar id="themes" v-if="$vuetify.breakpoint.smAndUp" style="height: 54px">
      <v-layout 
        id="themes_row" 
        ref="themes_row" 
        @wheel.prevent="toHorizontalScroll($event)"
      >
        <template v-if="themes && themes.length">
          <draggable 
            class="horizontal-drag"
            :list="themes" 
            :animation="500"
            @change="getOrderThemes"
            @start="dragging = true"
            @end="dragging = false"
          >
              <Theme
                draggable="true"
                @drop.native='dropTask($event, theme)'
                @dragover.prevent.native
                @dragenter.prevent.native
                v-for="theme in themes"
                :key="theme._id"
                :theme="theme"
                @click.native="selectTheme(theme)" 
                />
          </draggable> 
        </template>
        <div class="flex-center placeholder ml-2" v-else>Добавить новый раздел: </div>
        <div class="flex-center px-5"  v-if="themes_plus">
          <img height="33.91px" class="mb-7 pointer" @click="hidePlusThemes" src="./../../assets/images/components/button-add-green.png">
        </div>
        <div class="new_theme" v-else>
            <input
              type="text"
              class="input-themes new-theme mt-4"
              required
              autofocus 
              placeholder="Введите название раздела"
              v-model="themes_plus_name"
              @keyup.enter="addThemeHandle"
              @keypress.ctrl="addThemeHandle"
            > 
            <button @click="addThemeHandle" class="pl-2 pr-3 ok-button"><b>OK</b></button>
        </div>
      </v-layout>
    </v-toolbar>
    <div v-else>
      <div v-if="showMobileTheme"> 
        <div class="themes-mobile flex-center" v-if="notShowThemes">
          <div class="addTheme" v-if="addNewTheme"></div>
          <img @click="addNewTheme = true" class="ml-3" height="33.91px" src="./../../assets/images/components/button-add-grey.png">
          <div class="theme mx-4" v-if="themes.length && !editTheme" @click="notShowThemes = !notShowThemes">
            <div class="flex-center-between my-3 text-wrap">
              <div class="d-flex ml-4 text-wrap">
                <img height="16.36px" src="./../../assets/images/components/icon-folder.svg">
                <div class="roboto-normal-18 clr-black-38 ml-3" v-text="current ? current.name : themes[0].name"></div>
              </div>
              <img class="mr-3 ml-2" height="20px" src="./../../assets/images/components/arrow-up.svg">
            </div>
          </div>
          <input
            v-if="editTheme"
            class="input-themes-mobile-rename my-3"
            type="text"
            required
            autofocus
            v-model="name"
          >
          <div v-if="!themes.length" class="roboto-normal-18 clr-black-38 ml-6" @click="addNewTheme = true">Добавить новый раздел</div>
        </div>
        <div v-if="editTheme" class="button_change_mobile_task button_rename_theme pointer" @click="renameMobileTheme()">Готово</div>
        <div v-if="addNewTheme" v-click-outside="themesRenameOk">
          <input
            type="text"
            class="input-themes-mobile"
            required
            autofocus 
            placeholder="Введите название раздела"
            v-model="themes_plus_name"
          >
          <div class="fixed button_change_mobile_theme button_change_theme pointer" @click="addThemeHandleMobile()">Добавить</div>
        </div>
        <div v-if="!notShowThemes">
          <div class="themes-mobile-full flex-center z-index-200" v-click-outside="closeThemeList">
            <img class="ml-3" height="33.91px" src="./../../assets/images/components/button-add-grey.png">
            <div class="theme ml-4 mx-4 text-wrap" v-if="themes.length && !editTheme" @click="notShowThemes = !notShowThemes">
              <div class="flex-center-between my-3">
                <div class="d-flex ml-4 text-wrap">
                  <img height="16.36px" src="./../../assets/images/components/icon-folder.svg">
                  <div class="roboto-normal-18 clr-black-38 ml-3" v-text="current ? current.name : themes[0].name"></div>
                </div>
                <img class="mr-3 ml-2" height="20px" src="./../../assets/images/components/arrow-down.svg">
              </div>
              <div class="themes-list mt-n1 absolute">
                <div class="themes" v-for="theme in filteredThemes" :key="theme._id">
                  <div class="flex-center mb-5 mr-8 text-wrap" @click="selectTheme(theme)">
                    <img class="ml-4" height="13.78px" src="./../../assets/images/components/icon-folder.svg">
                    <div class="ml-4 roboto-normal-16 clr-black-38">{{theme.name}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="editTheme" class="button_change_mobile_task button_rename_theme pointer" @click="renameMobileTheme()">Готово</div>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
    // horizontal scroll
    import draggable from 'vuedraggable'
    import Theme from '../main/Theme'
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
    import {isURL, getPubFromURL} from '../../helpers'
    import helperMixin from '../../helpers/mixin'
    import ClickOutside from 'vue-click-outside'
    export default {
        name: 'ThemesBar',
        data() {
          return {
            themes_plus: true,
            themes_plus_name: '',
            isOverflowing: false,
            dragging: false,
            notShowThemes: true,
            addNewTheme: false,
            showMobileTheme: true,
            name: '',
            editTheme: false
          }
        },
        components: {
            Theme,
            draggable
        },      
        mixins: [helperMixin],
        computed:{
            ...mapGetters(['current','themes','current_task', 'picked_sub']),
            filteredThemes() {
              return this.current ? this.themes.filter(el => el._id != this.current._id) : this.themes
            }
        },      
        methods:{
          selectTheme(theme){
            this.SET_CURRENT(theme)
            this.TOGGLE_PICKED_SUB({sub: this.picked_sub, relNotices: [], relNoticesForSub: []})
            this.setRelavantNotices(theme.tasks.filter(el => !el.completed)[0])
            this.$router.push("/theme/" + theme.route_name)
            if(this.$vuetify.breakpoint.xsOnly && !this.notShowThemes) this.notShowThemes = true
            this.notShowThemes = false
          },
          hidePlusThemes(){
            this.themes_plus = false
          },
          addThemeHandle(){
            this.addTheme({name: this.themes_plus_name}).then(this.themesRenameOk).then(() => {
              const themes_id = this.themes.map(item => item._id)
              this.saveOrderThemes(themes_id)
              this.selectTheme(this.themes[this.themes.length - 1])
           })
          },
          addThemeHandleMobile() {
            this.addThemeHandle()
            this.addNewTheme = false
          },
          themesRenameOk(){
              this.themes_plus_name
              this.themes_plus = true
              this.themes_plus_name = ''
              this.addNewTheme = false
          },
          onResize(){
            this.isOverflowing = this.isOverflown(this.$refs.themes_row)
          },
          getOrderThemes() {
                const themes_id = this.themes.map(item => item._id)
                this.saveOrderThemes(themes_id)
          },
          async dropTask (evt, theme) {
            if(evt.dataTransfer.getData('dragTask')) {
                const dropTask = JSON.parse(evt.dataTransfer.getData('dragTask'))
                await this.moveTask({
                        theme_from_id: this.current._id,  
                        task_id: dropTask._id,
                        theme_to_id: theme._id,
                })
                const dragIds = this.current.tasks.map(item => item._id)
                const dropIds =  theme.tasks.map(item => item._id)
                this.saveOrderTasks({tasks_id: dragIds, _id: this.current._id})
                this.saveOrderTasks({tasks_id: dropIds, _id: theme._id})
            }
          }, 
          toHorizontalScroll(e) {
            e = window.event || e
            let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)))
            document.getElementById('themes_row').scrollLeft -= (delta*100)
          },
          renameMobileTheme() {
            this.renameTheme({_id: this.current._id, name: this.name}).then(() => {
              this.editTheme = false
              this.name = ''
            })
          },
          closeThemeList() {
            this.notShowThemes = true
          },
          ...mapActions(['addTheme','saveOrderThemes','addTask','delTask','saveOrderTasks','moveTask','setRelavantNotices', 'renameTheme']),
          ...mapMutations(['SET_ERROR', 'SET_CURRENT', 'TOGGLE_PICKED_SUB'])
        },
        mounted() {
          this.$root.$on('openMobileTheme', () => {
            this.showMobileTheme = true
          })
          this.$root.$on('closeMobileTheme', () => {
            this.showMobileTheme = false
          })
          this.$root.$on('renameMobileTheme', () => {
            this.editTheme = true
            this.name = this.current.name
          }) 
        },
        updated(){
          this.isOverflowing = this.isOverflown(this.$refs.themes_row)
        },
        directives: {
          ClickOutside
        }        
    }
</script>

<style lang="scss" scoped>
    .button_change_mobile_task{
        width: 150px !important;
        margin-bottom: 32px !important;
    }
    .themes_wrap{
        // position: sticky;
        // z-index: 9;
        top: 0;
    }
    .ok-button{
        font-size: 24px;
    }
	.feeds-button{
    border-bottom: 1px solid lightgray;
    align-self: flex-end;
    button{
      text-transform: none !important;	
    }
	}
	.spacer-border{
		border-bottom: 1px solid lightgray;
    align-self: flex-end;
	}
  #themes{
    width: 100%;    
    overflow: hidden;
    box-shadow: none;
    background: var(--cl-bg); 
    z-index:1;
    // border-bottom: 1px solid #e3e3e3;
  }
  .plus_button{
    font-size: 26px;
    border-bottom: 1px solid lightgray;
    height: 40px;
    align-self: flex-end;
    padding: 0 6px;
  }
  #themes_row{
    height:84px;
    overflow-x: auto;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    &::-webkit-scrollbar {
        display: none;
    }
  }
  #themes{
    &.theme--dark{
      background: #0e0e0e !important;
    }
  }
  .horizontal-drag {
    display: flex;
    align-items: flex-end;
    height: 84px;
  }
  .new_theme input::placeholder {
      font-size: 18px;
      color: gray;
      font-weight: 400;
  }
  .button_rename_theme {
      margin: 0px auto 15px;
      right: 0;
      left: 0;
      display:flex;
      flex-direction:column;
      align-items: center;
    }
  .themes-mobile {
    margin-top:10px;
    margin-bottom:22px;
    .addTheme {
      min-height: 100%;
      min-width: 600px;
      width: 100%;
      height: auto;
      position: fixed;
      top: 0;
      left: 0;
      background: rgba(87, 87, 87, 0.5);
      z-index: 111;
    }
    .theme {
      height: auto;
      width: calc(100% - 76px);
      background: #F5F5F5;
      border-radius: 6px;
    }
  }
  .themes-mobile-full {
    margin-top:10px;
    margin-bottom:22px;
    .theme {
      height: auto;
      width:100%;
      background: #FFFFFF;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
      border-radius: 6px 6px 0 0;
      .themes:first-child {
        margin-top:32px;
      }
      .themes-list {
        background:#FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
        border-radius: 0 0 6px 6px;
        max-height: 235px;
        width: calc(100% - 78px);
        z-index:100;
        overflow-x: hidden;
        overflow-y: auto;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        -webkit-overflow-scrolling: touch;
        white-space: nowrap;
        &::-webkit-scrollbar {
          display: none;
        }
    }
    }
  }
  .button_change_theme {
    position: fixed;
    margin: 170px auto 0px;
    right: 0;
    left: 0;
    display:flex;
    flex-direction:column;
    align-items: center;
    z-index: 112;
  }
</style>

<style lang="scss">
    #themes_top .v-toolbar__content{
        padding: 0 !important;
        height: 84px !important;
    }
    .new_theme{
      height:84px;
      width: 310px;
      background: #DEFFEF;
      &::placeholder {
          font-size: 18px;
          color: gray;
          font-weight: 400;
      }
    }   
</style>
